//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const icon = require("@/assets/pay-gold-card.png");
const checkIcon = require("@/assets/Repay/activeIcon@2x.png");
export default {
    name: "OpenGoldenCard",
    props: {
        value: {
            type: String,
        },
        vipVo: {
            type: Object,
        },
        repayPage: {
            type: Number,
        },
    },
    watch: {
        isOpenedGoldCard() {
            this.$emit("input", this.isOpenedGoldCard ? "y" : "n");
            this.sensorsRecord("h5_clk", {
                tgt_event_id: "h5_paycash_opengoldencard_button",
                tgt_name: "h5-paycash-拍金卡-是否勾选",
                url: location.href,
                page: "还款-拍金卡",
                param4: this.isOpenedGoldCard,
                param5: this.repayPage,
            });
        },
    },
    data() {
        return {
            isOpenedGoldCard: this.value === "y",
            icon,
            checkIcon,
        };
    },
    computed: {
        isNew() {
            return this.repayPage == 2;
        },
        goldenPageInfo() {
            // const { vipVo } = this.repayInitData;
            const {
                svipTypeName,
                repayCouponAmount,
                payBackAmount,
                svipOutPrice,
                loanCouponAmount,
                months,
                payTypeDesc,
            } = this.vipVo || {};
            if ([1, 3].includes(this.repayPage)) {
                return {
                    line1: `¥${svipOutPrice}${payTypeDesc}<span>${svipTypeName}</span>，本次还款立减${payBackAmount}元`,
                    line2: `每月领<span>${repayCouponAmount}</span>元还款红包，再送<span>${loanCouponAmount}</span>元借款免息券`,
                };
            }

            if ([2, 4].includes(this.repayPage)) {
                return {
                    line1: `¥${svipOutPrice}${payTypeDesc}${svipTypeName}，享<span>${
                        months * repayCouponAmount + loanCouponAmount
                    }</span>息费减免`,
                    line2: `<p>${repayCouponAmount}</p><p>元</p><p>×</p><p>${months}</p><p>月</p>`,
                };
            }

            return {};
        },
    },
};
